import styled, { css } from 'styled-components';
import { FlexColumn } from '../../../styled/common';

export const FilterContainer = styled(FlexColumn)`
  overflow: scroll;
  height: 100%;
  width: 100%;
  padding-bottom: 155px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  gap: 10px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 25px 40px;
    padding-bottom: 180px;
    background-color: ${({ theme }) => theme.colors.background.primary};
    gap: 30px;
  }

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    padding-bottom: 30px;
    padding-bottom: 180px;
  }
`;

export const modalFooterStyles = css`
  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    justify-content: center;
    button {
      width: 50%;
    }
  }

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    justify-content: flex-end;
    button {
      &:first-of-type {
        width: 193px;
      }
      &:last-of-type {
        width: 334px;
      }
    }
  }
`;

export const RangeFilterWithOptionsContainer = styled(FlexColumn)`
  gap: 15px;

  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    flex-direction: row;
    gap: 10px;
  }
`;

export const modalStyles = css`
  @media screen and (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    max-width: 975px;
  }
`;
